// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1472":"volto-dropdownmenu-manage","6346":"VoltoFormBlockEdit","6454":"Widgets","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"1472":"f95d1f91","6346":"0c89c876","6454":"ac119948","7051":"ac119948"}[chunkId] + ".chunk.css";
};